// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e2mg4","col":"styles_col__3TSOA"};